import { API_ENDPOINTS } from "@/api/services/adminEvents/apiEndPoints";
import { COMMON_API_ENDPOINTS } from "../../commonApi/apiEndPoints";
import { baseApi } from "@/utils/baseApi";

export const eventsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    fetchEvents: builder.query({
      query: () => ({
        url: API_ENDPOINTS.ADMIN_EVENTS.FETCH_EVENT(),
        method: "GET",
      }),
      transformResponse: (response) => response.data,
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "EVENTS", id: "LIST" }]
          : [{ type: "EVENTS", id: "LIST" }],
    }),

    fetchEventsForEmployees: builder.query({
      query: (key) => ({
        url: API_ENDPOINTS.ADMIN_EVENTS.FETCH_EVENT_FOR_EMP(key),
        method: "GET",
      }),
    }),

    fetchEventsForEmployeesYear: builder.query({
      query: (key) => ({
        url: API_ENDPOINTS.ADMIN_EVENTS.FETCH_EVENT_FOR_EMP_YEAR(key),
        method: "GET",
      }),
    }),
    fetchAttendees: builder.query({
      query: (key) => ({
        url: API_ENDPOINTS.ADMIN_EVENTS.FETCH_ATTENDEES(key),
        method: "GET",
      }),
      transformResponse: (response) => response.data,
    }),

    fetchActiveEmployees: builder.query({
      query: () => ({
        url: COMMON_API_ENDPOINTS.EMPLOYEES(),
        method: "GET",
      }),
    }),

    fetchFilteredEvents: builder.query({
      query: (params) => ({
        url: API_ENDPOINTS.ADMIN_EVENTS.FETCH_EVENT_BY_PARAMS(params),
        method: "GET",
      }),
      transformResponse: (response) => response.data,
      providesTags: (result) =>
        result && Array.isArray(result)
          ? [{ type: "EVENTS", id: "LIST" }]
          : [{ type: "EVENTS", id: "LIST" }],
    }),

    addEvents: builder.mutation({
      query: (formData) => {
        return {
          url: API_ENDPOINTS.ADMIN_EVENTS.ADD_EVENTS(),
          method: "POST",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "EVENTS", id: "LIST" }],
    }),
    editEvents: builder.mutation({
      query: ({ id, formData }) => {
        return {
          url: API_ENDPOINTS.ADMIN_EVENTS.EDIT_EVENTS(id),
          method: "PUT",
          body: formData,
        };
      },
      invalidatesTags: [{ type: "EVENTS", id: "LIST" }],
    }),
    deleteEvents: builder.mutation({
      query: (id) => {
        return {
          url: API_ENDPOINTS.ADMIN_EVENTS.DELETE_EVENTS(id),
          method: "DELETE",
        };
      },
      invalidatesTags: [{ type: "EVENTS", id: "LIST" }],
    }),
    fetchEmployeesCursor: builder.query({
      query: (cursor) =>
        API_ENDPOINTS.ADMIN_EVENTS.FETCH_EMPLOYEE_CURSOR(cursor),
      method: "GET",
      transformResponse: (response) => response?.data,
    }),
  }),
});

export const {
  useFetchEventsQuery,
  useFetchAttendeesQuery,
  useLazyFetchAttendeesQuery,
  useAddEventsMutation,
  useDeleteEventsMutation,
  useFetchEventsForEmployeesQuery,
  useFetchActiveEmployeesQuery,
  useEditEventsMutation,
  useFetchEventsForEmployeesYearQuery,
  // useFetchFilteredEventsQuery,
  useLazyFetchFilteredEventsQuery,
  useLazyFetchEmployeesCursorQuery,
} = eventsApi;
